import fs from 'node:fs'
import path from 'node:path'

export function detectNextMajorVersion(cwd: string): number {
  const pkgPath = path.join(cwd, 'package.json')
  if (!fs.existsSync(pkgPath)) return 16

  try {
    const pkg = JSON.parse(fs.readFileSync(pkgPath, 'utf-8'))
    const version = pkg.dependencies?.next ?? pkg.devDependencies?.next
    if (typeof version !== 'string') return 16

    const match = version.match(/(\d+)/)
    if (!match) return 16

    return Number.parseInt(match[1], 10)
  } catch {
    return 16
  }
}
